// NOTE: This file is stable and usually should not be modified.
// It is important that all functionality in this file is preserved, and should only be modified if explicitly requested.

import { useState } from 'react';
import { Button } from '@/components/ui/button.tsx';
import LoginDialog from './LoginDialog';
import SignupDialog from './SignupDialog';
import { useLoggedInAccounts } from '@/hooks/useLoggedInAccounts';
import { AccountSwitcher } from './AccountSwitcher';
import { cn } from '@/lib/utils';

export interface LoginAreaProps {
  className?: string;
}

export function LoginArea({ className }: LoginAreaProps) {
  const { currentUser } = useLoggedInAccounts();
  const [loginDialogOpen, setLoginDialogOpen] = useState(false);
  const [signupDialogOpen, setSignupDialogOpen] = useState(false);

  const handleLogin = () => {
    setLoginDialogOpen(false);
    setSignupDialogOpen(false);
  };

  return (
    <div className={cn("inline-flex items-center justify-center", className)}>
      {currentUser ? (
        <AccountSwitcher onAddAccountClick={() => setLoginDialogOpen(true)} />
      ) : (
        <button
          onClick={() => setLoginDialogOpen(true)}
          className="relative w-full bg-polaroid-white py-3 px-6 shadow-[0_2px_8px_rgba(45,27,78,0.1)] transition-all active:scale-[0.97] hover:-translate-y-0.5 hover:shadow-[0_4px_14px_rgba(45,27,78,0.14)]"
          style={{ transform: 'rotate(-1deg)' }}
        >
          {/* Mini tape strip */}
          <div
            className="absolute top-0 left-1/2 w-[60px] h-[14px] tape-rainbow"
            style={{ transform: 'translateX(-50%) translateY(-7px) rotate(2deg)' }}
          />
          <span className="font-hand text-lg font-bold text-pol-text">Log in</span>
        </button>
      )}

      <LoginDialog
        isOpen={loginDialogOpen}
        onClose={() => setLoginDialogOpen(false)}
        onLogin={handleLogin}
      />

      <SignupDialog
        isOpen={signupDialogOpen}
        onClose={() => setSignupDialogOpen(false)}
      />
    </div>
  );
}
